import {chainWalk, deepCopyObject} from "../../../util/Util";

export const updateConfigurationsInTesseractAssetObject = (asset, configurations, alias) => {
    const updatedAsset = deepCopyObject(asset);
    updatedAsset.assetDetails.alias = chainWalk(() => alias.toString(), "");
    updatedAsset.assetDetails.assetAttributes.testConfig =
        chainWalk(() => JSON.stringify(configurations.testConfig), "[]")
    updatedAsset.assetDetails.assetAttributes.stowConfig =
        chainWalk(() => JSON.stringify(configurations.stowConfig), "[]")
    return updatedAsset;
}


// WEBPACK FOOTER //
// ./src/components/devicemanagement/tesseract/datamodel/TesseractAssetModelResource.js